import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';

export function Slider({ images, descriptionImages }) {
    return (
        <>
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                pagination={{
                    type: 'progressbar',
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
            >
                {images.map((item, index) => (
                    <SwiperSlide className='w-100' key={index}>
                        {item.includes('mp4') 
                            ? 
                            <video className='w-100' controls>
                                <source src={process.env.PUBLIC_URL + item} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            :
                            <img className='slider__img w-100' src={item} alt={descriptionImages} /> 
                        }
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
}